// import skills from "./skills.js"

const protounits = require("@frog/source/data/units.csv")
const headers = protounits.shift()

const images = {
    "enemy": require("@frog/source/images/ld47/baddie.png"),
    "box": require("@frog/source/images/ld47/Level 1 Crate.png"),
    "puller": require("@frog/source/images/ld47/ludumDare47_characterUnit2.png"),
    "pusher": require("@frog/source/images/ld47/ludumDare47_characterUnit1.png"),
    "flipper": require("@frog/source/images/ld47/ludumDare47_characterUnit3.png"),
    "aoe-er": require("@frog/source/images/ld47/ludumDare47_characterUnit4.png"),
}

const ASSET_DOMAIN = "https://frog-tactics.s3-us-west-2.amazonaws.com"

// "family": protounit["Family"].toLowerCase(),
// "level": Number.parseInt(protounit["Level"]),
// "tag": protounit["Tag"].toLowerCase(),
// "rarity": protounit["Rarity"],
// "isWhitelisted": protounit["Is Whitelisted"] == "*",
// "region": protounit["Region"],
// "portrait": ASSET_DOMAIN + "/assets/images/pokemon/portraits/" + paddednumber + ".jpg",

// units["family:" + unit.family + "/" + "level:" + unit.level] = unit
//
// units["rarity:" + unit.rarity] = units["rarity:" + unit.rarity] || []
// units["rarity:" + unit.rarity].push(unit)
//
// units["level:" + unit.level] = units["level:" + unit.level] || []
// units["level:" + unit.level].push(unit)
//
// units["tag:" + unit.tag] = units["tag:" + unit.tag] || []
// units["tag:" + unit.tag].push(unit)

const units = {}

const elements = {
    "Fire": "fire",
    "Grass": "grass",
    "Leaf": "grass",
    "Wood": "grass",
    "Water": "water",
    "Ground": "ground",
    "Rock": "ground",
    "Metal": "metal",
    "Lightning": "lightning",
    "Electric": "lightning",
    "Normal": "neutral",
    "Neutral": "neutral",
}

// TODO: Parse this using Parser.js!!

protounits.forEach((protounit) => {
    if(protounit.length == 1) {
        return
    }

    headers.forEach((header, index) => {
        protounit[header] = protounit[index]
    })

    const unit = {
        "reference": protounit["Reference"],

        "name": protounit["Name"],
        // "displayName": protounit["Name"],
        "number": Number.parseInt(protounit["Number"]) || 0,

        // "element": elements[protounit["Element 1"]] || "neutral",

        "maxhealth": Number.parseInt(protounit["Health"]),
        // "power": Number.parseInt(protounit["Power"]),
        "moverange": Number.parseInt(protounit["Move Range"]),
        "skills": [
            protounit["Skill 1"],
            protounit["Skill 2"],
            protounit["Skill 3"],
        ].filter((skill) => !!skill),

        // "family": protounit["Family"].toLowerCase(),
        // "level": Number.parseInt(protounit["Level"]),
        // "maxlevel": Number.parseInt(protounit["Max Level"]),
    }

    let paddednumber = (unit.number < 100 ? "0" : "") + (unit.number < 10 ? "0" : "") + (unit.number || 0)
    // unit.image = ASSET_DOMAIN + "/assets/images/pokemon/oakdex/" + paddednumber + ".png"
    // unit.image = require("@frog/source/assets/images/pokemon/oakdex/" + paddednumber + ".png") // DEBUG
    unit.image = images[unit.reference]

    if(unit.reference != undefined) {
        units[unit.reference] = unit
    }

    units["number:" + unit.number] = unit
    units["name:" + unit.name.toLowerCase()] = unit

    units["family:" + unit.family + "/level:" + unit.level] = unit

    units["all"] = units["all"] || []
    units["all"].push(unit)
})

export default units
